import axios from "axios";

if (localStorage.token) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.token}`;
}

if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = process.env.VUE_APP_URL_PRODUCTION;
} else {
  axios.defaults.baseURL = process.env.VUE_APP_URL_LOCAL;
}

export default axios;
